import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.access');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-access',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.access/view.scss */
:host {
  display: block;
}

.access-page {
  width: 100%;
  max-width: 440px;
  margin: 0 auto;
}

.access-heading {
  margin-bottom: 28px;
}

.back-link {
  display: flex;
  min-height: 40px;
  align-items: center;
  margin: 0 0 20px -8px;
  padding: 0 8px;
  border: 0;
  border-radius: 8px;
  color: #536761;
  background: transparent;
  font-family: inherit;
  font-size: 14px;
  font-weight: 700;
  gap: 7px;
}

.back-link:hover {
  color: var(--kiom-primary);
  background: #eaf2ef;
}

.access-heading h2 {
  margin: 0;
  color: var(--kiom-ink);
  font-size: clamp(34px, 4vw, 38px);
  line-height: 1.2;
  letter-spacing: -0.035em;
}

.access-heading p {
  margin: 12px 0 0;
  color: #536761;
  font-size: 14px;
  line-height: 1.65;
  word-break: keep-all;
}

.form-alert {
  display: flex;
  align-items: flex-start;
  margin-bottom: 20px;
  padding: 13px 14px;
  border: 1px solid;
  border-radius: 10px;
  font-size: 14px;
  line-height: 1.55;
  gap: 9px;
}

.form-alert svg {
  width: 18px;
  min-width: 18px;
  margin-top: 1px;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 2;
}

.form-alert.is-error {
  border-color: #d9a19b;
  color: #7a302b;
  background: #fff3f2;
}

.form-alert.is-success {
  border-color: #a8cfc2;
  color: #245d50;
  background: #edf7f3;
}

.access-form {
  display: grid;
  gap: 18px;
}

.field-group {
  min-width: 0;
}

.field-group > label {
  display: block;
  margin-bottom: 8px;
  color: #334b45;
  font-size: 14px;
  font-weight: 700;
}

.field-group input[type=email],
.field-group input[type=password],
.field-group input[type=text] {
  width: 100%;
  height: 54px;
  padding: 0 15px;
  border: 1px solid #829891;
  border-radius: 10px;
  color: var(--kiom-ink);
  background: white;
  font-family: inherit;
  font-size: 16px;
  outline: none;
  transition: border-color 0.15s, box-shadow 0.15s, background 0.15s;
}

.field-group input:hover {
  border-color: #607a72;
}

.field-group input:focus {
  border-color: var(--kiom-primary);
  box-shadow: 0 0 0 3px rgba(23, 111, 91, 0.14);
}

.field-group input::placeholder {
  color: #647872;
}

.field-group.has-error input {
  border-color: #ad4a43;
  background: #fffafa;
}

.field-group.has-error input:focus {
  box-shadow: 0 0 0 3px rgba(173, 74, 67, 0.13);
}

.input-with-action {
  position: relative;
}

.input-with-action input {
  padding-right: 82px !important;
}

.password-toggle {
  position: absolute;
  top: 5px;
  right: 5px;
  min-width: 66px;
  height: 44px;
  padding: 0 10px;
  border: 0;
  border-radius: 8px;
  color: #285f53;
  background: #edf4f1;
  font-family: inherit;
  font-size: 13px;
  font-weight: 700;
}

.password-toggle:hover {
  color: #143f36;
  background: #dfece7;
}

.field-support {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  margin-top: 8px;
  gap: 6px 12px;
}

.field-hint,
.field-error,
.caps-warning {
  display: block;
  font-size: 13px;
  line-height: 1.5;
}

.field-hint {
  color: #536761;
}

.field-error {
  margin-top: 7px;
  color: #922f2a;
  font-weight: 700;
}

.caps-warning {
  color: #8a4b0b;
  font-weight: 700;
}

.password-note {
  margin-top: 8px;
}

.form-options {
  display: flex;
  justify-content: flex-end;
  margin-top: -6px;
}

.text-button {
  min-height: 40px;
  padding: 0 6px;
  border: 0;
  border-radius: 7px;
  color: #1e6656;
  background: none;
  font-family: inherit;
  font-size: 14px;
  font-weight: 700;
}

.text-button:hover {
  color: #0f4f41;
  background: #e8f1ee;
}

.form-link {
  justify-self: center;
}

.primary-button {
  width: 100%;
  height: 54px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 10px;
  color: white;
  background: var(--kiom-primary);
  font-family: inherit;
  font-size: 15px;
  font-weight: 700;
  gap: 8px;
  transition: background 0.15s, transform 0.15s;
}

.primary-button:hover:not(:disabled) {
  background: var(--kiom-primary-dark);
}

.primary-button:active:not(:disabled) {
  transform: translateY(1px);
}

.primary-button svg {
  width: 17px;
  height: 17px;
  fill: none;
  stroke: currentColor;
  stroke-width: 2;
}

.primary-button:disabled {
  cursor: wait;
  opacity: 0.68;
}

.account-prompt {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 24px;
  color: #536761;
  font-size: 14px;
  gap: 6px;
}

.account-prompt a {
  display: inline-flex;
  min-height: 40px;
  align-items: center;
  padding: 0 5px;
  border-radius: 7px;
  color: #1e6656;
  font-weight: 700;
}

.account-prompt a:hover {
  color: #0f4f41;
  background: #e8f1ee;
}

@media (max-width: 520px) {
  .access-heading {
    margin-bottom: 24px;
  }
  .access-heading h2 {
    font-size: 32px;
  }
}`],
})
export class PageAccessComponent implements OnInit {
    public submitting: boolean = false;
    public mode: string = 'login';
    public showPassword: boolean = false;
    public showNewPassword: boolean = false;
    public capsLockOn: boolean = false;
    public formError: string = '';
    public formStatus: string = '';
    public fieldErrors: any = {};
    public data: any = {
        email: '',
        password: '',
        token: '',
        new_password: ''
    };

    private readonly emailPattern: RegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    private readonly allowedModes: string[] = [
        'login',
        'reset-request',
        'reset-password',
        'verify-email'
    ];

    constructor(@Inject( Service) public service: Service) { }

    public get pageTitle(): string {
        if (this.mode === 'reset-request') return '비밀번호 재설정';
        if (this.mode === 'reset-password') return '새 비밀번호 설정';
        if (this.mode === 'verify-email') return '이메일 확인';
        return '로그인';
    }

    public get pageDescription(): string {
        if (this.mode === 'reset-request') {
            return '가입한 이메일을 입력하면 비밀번호를 다시 설정할 수 있는 안내를 보내드립니다.';
        }
        if (this.mode === 'reset-password') {
            return '앞으로 로그인할 때 사용할 새 비밀번호를 입력해 주세요.';
        }
        if (this.mode === 'verify-email') {
            return '가입할 때 입력한 이메일 주소가 맞는지 확인합니다.';
        }
        return '';
    }

    public async ngOnInit() {
        await this.service.init();
        let params = new URLSearchParams(window.location.search);
        let requestedMode = params.get('mode') || 'login';
        this.mode = this.allowedModes.indexOf(requestedMode) >= 0 ? requestedMode : 'login';
        this.data.token = params.get('token') || '';

        if (this.service.auth.check()) {
            this.moveFromSession();
            return;
        }

        if (this.mode === 'reset-password' && !this.data.token) {
            this.setFormError('재설정 정보가 없는 링크입니다. 새 재설정 링크를 요청해 주세요.');
        }
        if (this.mode === 'verify-email' && !this.data.token) {
            this.setFormError('이메일 확인 정보가 없는 링크입니다. 가입 안내 메일의 링크를 다시 확인해 주세요.');
        }
    }

    private moveFromSession() {
        let session = this.service.auth.session || {};
        if (session.account_status !== 'ACTIVE') {
            this.service.href('/status/pending');
            return;
        }
        let portals = session.portals || [];
        if (portals.length === 1) {
            this.service.href('/' + portals[0]);
            return;
        }
        this.service.href(portals.length ? '/workspace' : '/status/pending');
    }

    private clearFeedback() {
        this.formError = '';
        this.formStatus = '';
        this.fieldErrors = {};
        this.capsLockOn = false;
    }

    private focusElement(id: string) {
        window.setTimeout(() => {
            let element = document.getElementById(id) as HTMLElement;
            if (element) element.focus();
        });
    }

    private setFormError(message: string) {
        this.formStatus = '';
        this.formError = message;
        this.focusElement('access-form-error');
    }

    private responseMessage(result: any, fallback: string): string {
        if (result && result.data && result.data.message) return result.data.message;
        return fallback;
    }

    private replaceAccessUrl(query: string = '') {
        let nextUrl = '/access' + (query ? '?' + query : '');
        window.history.replaceState({}, document.title, nextUrl);
    }

    private validateEmail(focusId: string): boolean {
        let email = String(this.data.email || '').trim();
        this.data.email = email;
        if (!email) {
            this.fieldErrors.email = '이메일을 입력해 주세요.';
            this.focusElement(focusId);
            return false;
        }
        if (!this.emailPattern.test(email)) {
            this.fieldErrors.email = '이메일 주소 형식을 확인해 주세요.';
            this.focusElement(focusId);
            return false;
        }
        return true;
    }

    private validateLogin(): boolean {
        let emailValid = this.validateEmail('login-email');
        if (!this.data.password) {
            this.fieldErrors.password = '비밀번호를 입력해 주세요.';
            if (emailValid) this.focusElement('login-password');
        }
        return emailValid && !!this.data.password;
    }

    private validateNewPassword(): boolean {
        let password = String(this.data.new_password || '');
        let message = '';
        if (!password) {
            message = '새 비밀번호를 입력해 주세요.';
        } else if (password.length < 10) {
            message = '비밀번호는 10자 이상이어야 합니다.';
        } else if (!/[A-Za-z]/.test(password)) {
            message = '비밀번호에 영문자를 포함해 주세요.';
        } else if (!/[0-9]/.test(password)) {
            message = '비밀번호에 숫자를 포함해 주세요.';
        } else if (new TextEncoder().encode(password).length > 72) {
            message = '비밀번호가 너무 깁니다. 한글은 3바이트로 계산됩니다.';
        }

        if (message) {
            this.fieldErrors.new_password = message;
            this.focusElement('new-password');
            return false;
        }
        return true;
    }

    public clearFieldError(field: string) {
        if (this.fieldErrors[field]) delete this.fieldErrors[field];
        this.formError = '';
    }

    public togglePassword(target: string) {
        if (target === 'reset') {
            this.showNewPassword = !this.showNewPassword;
            this.focusElement('new-password');
            return;
        }
        this.showPassword = !this.showPassword;
        this.focusElement('login-password');
    }

    public updateCapsLock(event: KeyboardEvent) {
        this.capsLockOn = !!(
            event && event.getModifierState && event.getModifierState('CapsLock')
        );
    }

    public hideCapsLock() {
        this.capsLockOn = false;
    }

    public async login() {
        if (this.submitting) return;
        this.clearFeedback();
        if (!this.validateLogin()) return;

        this.submitting = true;
        try {
            let result: any = await this.service.request.post('/api/account/login', {
                email: this.data.email,
                password: this.data.password
            });
            if (result.code !== 200) {
                this.setFormError(this.responseMessage(result, '이메일 또는 비밀번호를 확인해 주세요.'));
                return;
            }
            location.href = result.data && result.data.next ? result.data.next : '/workspace';
        } catch (error) {
            this.setFormError('서버에 연결하지 못했습니다. 잠시 후 다시 시도해 주세요.');
        } finally {
            this.submitting = false;
        }
    }

    public openResetRequest() {
        this.clearFeedback();
        this.mode = 'reset-request';
        this.data.token = '';
        this.data.new_password = '';
        this.showNewPassword = false;
        this.replaceAccessUrl('mode=reset-request');
        this.focusElement('reset-email');
    }

    public async requestReset() {
        if (this.submitting) return;
        this.clearFeedback();
        if (!this.validateEmail('reset-email')) return;

        this.submitting = true;
        try {
            let result: any = await this.service.request.post('/api/account/password/reset/request', {
                email: this.data.email
            });
            if (result.code !== 202) {
                this.setFormError(this.responseMessage(result, '재설정 메일을 보내지 못했습니다. 잠시 후 다시 시도해 주세요.'));
                return;
            }
            this.mode = 'login';
            this.data.password = '';
            this.formStatus = '입력한 주소와 일치하는 계정이 있으면 재설정 메일을 보냈습니다.';
            this.replaceAccessUrl();
            this.focusElement('access-form-status');
        } catch (error) {
            this.setFormError('서버에 연결하지 못했습니다. 잠시 후 다시 시도해 주세요.');
        } finally {
            this.submitting = false;
        }
    }

    public async confirmReset() {
        if (this.submitting) return;
        this.formError = '';
        this.formStatus = '';
        this.fieldErrors = {};
        if (!this.data.token) {
            this.setFormError('재설정 정보가 없는 링크입니다. 새 재설정 링크를 요청해 주세요.');
            return;
        }
        if (!this.validateNewPassword()) return;

        this.submitting = true;
        try {
            let result: any = await this.service.request.post('/api/account/password/reset/confirm', {
                token: this.data.token,
                new_password: this.data.new_password
            });
            if (result.code !== 200) {
                this.setFormError(this.responseMessage(result, '비밀번호를 변경하지 못했습니다. 새 링크를 요청해 주세요.'));
                return;
            }
            this.mode = 'login';
            this.data.token = '';
            this.data.password = '';
            this.data.new_password = '';
            this.showNewPassword = false;
            this.formStatus = '비밀번호를 변경했습니다. 새 비밀번호로 로그인해 주세요.';
            this.replaceAccessUrl();
            this.focusElement('access-form-status');
        } catch (error) {
            this.setFormError('서버에 연결하지 못했습니다. 잠시 후 다시 시도해 주세요.');
        } finally {
            this.submitting = false;
        }
    }

    public async verifyEmail() {
        if (this.submitting) return;
        this.formError = '';
        if (!this.data.token) {
            this.setFormError('이메일 확인 정보가 없는 링크입니다. 가입 안내 메일의 링크를 다시 확인해 주세요.');
            return;
        }

        this.submitting = true;
        try {
            let result: any = await this.service.request.post('/api/account/email/verify', {
                token: this.data.token
            });
            if (result.code !== 200) {
                this.setFormError(this.responseMessage(result, '이메일을 확인하지 못했습니다. 링크가 만료되었는지 확인해 주세요.'));
                return;
            }
            location.href = result.data && result.data.next ? result.data.next : '/status/pending';
        } catch (error) {
            this.setFormError('서버에 연결하지 못했습니다. 잠시 후 다시 시도해 주세요.');
        } finally {
            this.submitting = false;
        }
    }

    public backToLogin() {
        this.clearFeedback();
        this.mode = 'login';
        this.data.token = '';
        this.data.new_password = '';
        this.showNewPassword = false;
        this.replaceAccessUrl();
        this.focusElement('login-email');
    }
}

export default PageAccessComponent;